/**
 * Reusable stateless form component for StudyUser
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third party libraries
import _ from 'lodash';
import classNames from 'classnames';
import { DateTime } from 'luxon';


const StudyUserInfo = ({
  course
  , isArchived
  , loggedInUser
  , match
  , site 
  , siteLocation 
  , sponsor
  , study
  , studyRole 
  , studyUser
  , user
  , viewingAs
}) => {
  const btnClass = classNames(
    'yt-btn'
    , 'x-small'
    , { 'disabled': isArchived }
  )

  return (
    <div className="content-container">
      <div className="yt-row space-between center-vert">
        <p><strong>Program User Info</strong></p>
        { studyUser ?
            <div data-tip data-for={studyUser._id}>
              <Link className={btnClass} to={`${match.url}/update-user`}> Update Program Permission </Link>
            </div>
          :
            null
        }
      </div>
      
      <h2> <small>Program user email:</small><br/> { studyUser.email } </h2>
      { viewingAs === 'admin' ?
        <div>
          <small> <strong>User's name:</strong></small>
          <p>{user ? user.firstName : ''} {user ? user.lastName : ''}</p>
          <small> <strong>User's email/username:</strong></small>
          <p><em>{user ? user.username : 'n/a'}</em></p>
          <Link to={`/admin/users/${user._id}`}>View/edit user</Link>
        </div>
        :
        null
      }
      <hr/>
      <small><strong>Role: </strong></small>
      <p>{studyRole ? studyRole.role : <em>Unassigned</em>}</p>
      <small><strong>Site: </strong></small>
      <p>{studyUser.siteNumber ? studyUser.siteNumber : <em>Unassigned</em>}</p>
      { site && loggedInUser.admin ? 
        <div>
          <small><strong>Database-backed site: </strong></small>
          <p><Link to={`/admin/authoring/studies/${studyUser._group}/sites/${site._id}`}>{site.name} - {site.number}</Link></p>
        </div>
        : loggedInUser.admin ? 
        <p><small><em><strong>NOTE: </strong>Not database-backed &mdash; <Link to={`/admin/authoring/studies/${studyUser._group}/sites/new?siteNumber=${studyUser.siteNumber}`}>Add site to database</Link></em></small></p>
        :
        null 
      }
      { site && siteLocation ?
        <div>
          <p><small><strong>Site location: </strong></small></p> 
          { loggedInUser.admin ? 
            <p><Link to={`/admin/site-locations/${siteLocation._id}`}>{siteLocation.name}</Link></p>
            :
            null 
          }
          {siteLocation.address.street1 ?
            <div>
              <small>{siteLocation.address.street1} {siteLocation.address.street2}</small>
            </div>
            :
            null 
          }
          <small>{siteLocation.address.city}, {siteLocation.address.state} {siteLocation.address.postal}{siteLocation.address.country}</small>
        </div> 
        : site && loggedInUser.admin ?  
        <p><small><em><Link to={`/admin/authoring/studies/${studyUser._group}/sites/${site._id}/link-location`}>Create or link a site location</Link></em></small></p>
        : 
        null 
      }
      <hr/>
      <small><strong>Sponsor:</strong></small>
      <p>{sponsor ? sponsor.name : ''} </p>
      <small><strong>Program:</strong></small>
      <p>{study ? study.name : ''} </p>
      <small><strong>Course:</strong></small>
      <p>{course ? course.title : <em>waiting for user to start</em>} </p>
      <hr/>
      <small><strong>Admin for this Program?:</strong></small>
      <p>{studyUser.admin ? "YES" : "NO"} </p>
      <small><strong>Allowed to view reports for this Program?:</strong></small>
      <p>{studyUser.permissions.includes('view-reports') ? "YES" : "NO"} </p>
      <small><strong>Allowed to view ADVANCED reports for this Program?:</strong></small>
      {/* <small><strong>Expiration:</strong></small>
      <p>{studyUser.expiration} </p> */}
      <small><strong>Status:</strong></small>
      <p>{studyUser.status.charAt(0).toUpperCase() + studyUser.status.slice(1)} </p>

      <br/>
      <Link
        className="yt-btn warning"
        to={`/admin/audit-logs/study-user/${studyUser._id}`}
        target="_blank"
      >
        Object History &rarr;
      </Link>
    </div>
  )
}

StudyUserInfo.propTypes = {
  course: PropTypes.object
  , loggedInUser: PropTypes.object.isRequired
  , site: PropTypes.object 
  , siteLocation: PropTypes.object 
  , sponsor: PropTypes.object
  , study: PropTypes.object
  , studyRole: PropTypes.object 
  , studyUser: PropTypes.object.isRequired
  , user: PropTypes.object
  , viewingAs: PropTypes.string
}

StudyUserInfo.defaultProps = {
  course: null
  , site: null 
  , siteLocation: null 
  , sponsor: null
  , study: null
  , studyRole: null 
  , user: null
  , viewingAs: 'study-admin'
}

export default withRouter(StudyUserInfo);



// WEBPACK FOOTER //
// modules/studyUser/components/StudyUserInfo.js.jsx